export const KIT_TABS = [
  { label: 'Overview', index: 0 },
  { label: 'Function', index: 1 },
  { label: 'Dev', index: 2 },
  { label: 'Setting', index: 3 },
];
